import { render } from "./TheProjects.vue?vue&type=template&id=44a5d120&ts=true"
import script from "./TheProjects.vue?vue&type=script&lang=ts"
export * from "./TheProjects.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__